import simple from './simple';
import amazon from './amazon';
import wirecutter from './wirecutter';
import samix from './samix';

const comparisonTemplates = [simple, amazon, wirecutter, samix];

export default comparisonTemplates;
